import { List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import { SkillDto } from "../../../types/applicationTypes";
import { languageSkillLevels } from "../../../utils/skillLevels";
import ProfileDataCard from "./ProfileDataCard";

interface LanguagesProps {
  languages: SkillDto[];
}

/**
 * This component displays the languages of an applicant.
 * @param languages The languages of an applicant
 * @returns The languages of an applicant.
 */
const Languages = ({ languages }: LanguagesProps) => {
  /**
   * Maps the level of the language to the corresponding text
   * @param level The level of the language
   * @returns The text of the level
   */
  const mapLevelToText = (level: number) => {
    return languageSkillLevels.find((languageSkill) => languageSkill.level === Number(level))?.label;
  };

  return (
    <ProfileDataCard title="Sprachen">
      <List
        disablePadding
        sx={{ listStyleType: "square", listStylePosition: "outside", pl: languages.length === 0 ? 0 : 2 }}
      >
        {languages.length === 0 ? (
          <Typography>Keine Angaben</Typography>
        ) : (
          languages.map((language, index) => {
            return (
              <ListItem key={index} disablePadding sx={{ display: "list-item" }}>
                <ListItemText>
                  {language.name} ({mapLevelToText(language.level)})
                </ListItemText>
              </ListItem>
            );
          })
        )}
      </List>
    </ProfileDataCard>
  );
};

export default Languages;
